import { render, staticRenderFns } from "./TaskSummaryCard.vue?vue&type=template&id=d1bae9a4"
import script from "./TaskSummaryCard.vue?vue&type=script&lang=js"
export * from "./TaskSummaryCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports